import { FC, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { SnackbarUtils } from 'utils/snackbarUtilsConfigurator'; // ajusta la ruta según tu estructura
import { SystemModules } from 'src/types/systemModules';
import useClaims from 'src/hooks/useClaims';
import { PermissionLevel } from 'src/types/profilePermission';

interface RequireAuthProps {
  systemModules: SystemModules;
  children: ReactNode;
}

const RequireAuth: FC<RequireAuthProps> = ({ children, systemModules }) => {
  const permissionLevel = useClaims(systemModules);
  const location = useLocation();

  if (permissionLevel === PermissionLevel.None) {
    SnackbarUtils.warning('No tienes permiso para acceder a este módulo');
    return (
      <Navigate
        to="/"
        state={{ from: location }}
        replace
      />
    );
  }

  return <>{children}</>;
};

export default RequireAuth;
